import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ChecklistNotesComponent } from '@app/modules/checklist/components/dialogs/checklist-notes/checklist-notes.component';
import { RootStoreState, vaultStoreActions } from '@app/root-store';
import { VaultStoreEffects } from '@app/root-store/vault-store/effects';
import { SharedConfirmationDialogComponent } from '@app/shared/component/shared-confirmation-dialog/shared-confirmation-dialog.component';
import { foreverDeletedRemainingDays } from '@app/shared/models/constants/constant';
import { CommonService, DocumentService, NotifySummaryUpdateService } from '@app/shared/services';
import { takeWhile } from 'rxjs/operators';
import { environment } from '@env/environment';
import { Store } from '@ngrx/store';
import * as fileSaver from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { FileManagerComponent } from '../../../access-manager/file-manager.component';
import { ActivityLogFileComponent } from '../../../activity-log-file/activity-log-file.component';
import { AddDocumentComponent } from '../../../add-document/add-document.component';
import { AskSecurityKeyPasswordComponent } from '../../../dialogs/ask-security-key-password/ask-security-key-password.component';
import { CreateShareLinkComponent } from '../../../dialogs/create-share-link/create-share-link.component';
import { AddFolderDialogWithVaultComponent } from '../../../dialogs/add-folder-dialog-with-vault/add-folder-dialog-with-vault.component';
import { NotifyEstateActiveTabUpdate } from '@app/shared/services/notify-estate-active-tab-update/notify-estate-active-tab-update.service';
import { InaccessibleWallDialogComponent } from '@app/shared/component/inaccessible-wall-dialog/inaccessible-wall-dialog.component';
import moment from 'moment';
import { ShareService } from '@app/shared/services/vault/share.service';
import { getFileExtension } from '@app/shared/utils';
import { ChecklistFloaterActionComponent } from '../checklist-floater-action/checklist-floater-action.component';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

enum ChecklistType {
  workspace = 'workspace',
  vault = 'vault',
  workspaceFiles = 'workspaceFiles',
}
export enum TemplateStatus {
  notStarted = 'notStarted',
  workingOnIt = 'workingOnIt',
  review = 'review',
  needsAttention = 'needsAttention',
  complete = 'complete',
}

@AutoUnsubscribe()
@Component({
  selector: 'individual-group-files-list-items',
  templateUrl: './individual-group-files-list-items.component.html',
  styleUrls: ['./individual-group-files-list-items.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IndividualGroupFilesListItemsComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {
  screenWidth: number;
  screenDataTableHeight: number;
  @Input() document_type: boolean = false;
  @Input() id;
  @Input() selected_folder_id;
  @Input() isSharedFiles = false;
  @Input() fileListItems = [];
  @Input() group = [];
  @Input() selectedChecklistEvent: Array<any> = [];
  @Input() selectedChecklistItems: Array<any> = [];
  @Input() globalSearch = false;
  @Input() filterValue = '';
  @Input() isGlobalSearch = false;
  @Input() hideCheckbox = false;
  @Input() selectedSenderFilter = [];
  @Input() selectedSourceFilter = [];
  @Input() statusList = [];
  @Input() selectedStatusList = [];
  @Input() selectedDocumentTypeFilter = [];
  @Input() hideSelectAllCheckbox = false;
  @Output() someEvent = new EventEmitter<object>();
  @Output() toggleDuplicateEvent = new EventEmitter<object>();
  @Output() AddTemplateEvent = new EventEmitter<object>();
  @Output() updateUiEvent = new EventEmitter<object>();
  @Output() openTemplateRegisterEvent = new EventEmitter<object>();

  selectedItemsArray: Array<any> = [];

  @Input() isSharedWithOther = false;
  @Input() isSharedWithMe = false;
  @Input() is_table_active = false;

  assetListItemCount = 2;
  @Input() showTagFilter = false;
  @Input() tagList = [];
  @Input() selectedTagList = [];
  @Input() selectedTypeList = [];
  @Input() typeList = [];
  @Input() vaultList = [];
  @Input() selectedVaultList = [];
  @Input() sentFromList = [];
  @Input() selectedSentFromList = [];
  @Input() suggestionTemplateCount = 0;
  @Input() dateAddedList = [];
  @Input() selectedDateAddedList = '';

  @Input() lastUpdatedList = [];
  @Input() selectedLastUpdatedList = [];
  @Input() isDuplicateFormName: (formName: string) => boolean;
  @Input() isDefaultTemplateName: (item: any) => boolean;

  @ViewChild('floater') checklistFloaterActionComponent: ChecklistFloaterActionComponent;
  @ViewChild('floaterContainer') floaterContainer: ElementRef | undefined;
  @ViewChild('filtersContainer') filtersContainer: ElementRef | undefined;
  checklistType = ChecklistType.workspaceFiles;
  fromVault = false;
  allChecked = false;
  currentActiveChecklistType = 'remaining';
  sortedArrayByStatus = false;
  isOnSharedWorkspace = false;
  sortedArrayByAccessible = false;
  sortedArrayByTags = false;
  sortedArrayByLinks = false;
  is_shared_with_other = false;
  is_my_data = false;
  subscription: Subscription = new Subscription();
  assetListItems = [];
  security_key;
  @Input() searchText = '';
  defaultFolders;
  sk;
  files = [];
  stateObject;
  user;
  userId;
  componentActive = true;
  vaultStateObject$: any;
  sortedArrayByName = false;
  sortedArrayByType = false;
  sortedArrayBySize = false;
  initialSort = 'date';
  filteredFileItems = [];

  templateStatuses = [
    {
      type: 'Not Started',
      status: TemplateStatus.notStarted,
    },
    {
      type: 'Working on it',
      status: TemplateStatus.workingOnIt,
    },
    {
      type: 'Review',
      status: TemplateStatus.review,
    },
    {
      type: 'Needs Attention',
      status: TemplateStatus.needsAttention,
    },
    {
      type: 'Complete',
      status: TemplateStatus.complete,
    },
  ];

  starHoverItemId: number | string | null = null;
  private starUpdatingMap: Record<string, boolean> = {};

  private readonly templateStatusLabels: Record<string, string> = {
    [TemplateStatus.notStarted]: 'Not Started',
    [TemplateStatus.workingOnIt]: 'Working on it',
    [TemplateStatus.review]: 'Review',
    [TemplateStatus.needsAttention]: 'Needs Attention',
    [TemplateStatus.complete]: 'Complete',
  };

  private readonly templateStatusButtonClassMap: Record<string, string> = {
    [TemplateStatus.notStarted]: 'status-menu-button-notStarted',
    [TemplateStatus.workingOnIt]: 'status-menu-button-workingOnIt',
    [TemplateStatus.review]: 'status-menu-button-review',
    [TemplateStatus.needsAttention]: 'status-menu-button-needsAttention',
    [TemplateStatus.complete]: 'status-menu-button-complete',
  };

  private readonly templateStatusMenuClassMap: Record<string, string> = {
    [TemplateStatus.notStarted]: 'status-menu-item status-menu-item-notStarted',
    [TemplateStatus.workingOnIt]: 'status-menu-item status-menu-item-workingOnIt',
    [TemplateStatus.review]: 'status-menu-item status-menu-item-review',
    [TemplateStatus.needsAttention]: 'status-menu-item status-menu-item-needsAttention',
    [TemplateStatus.complete]: 'status-menu-item status-menu-item-complete',
  };

  getTemplateStatusLabel(status: string | null | undefined): string {
    if (!status) {
      return this.templateStatusLabels[TemplateStatus.notStarted];
    }
    return this.templateStatusLabels[status] ?? status;
  }

  defaultStatusList = [
    { key: this.templateStatusLabels[TemplateStatus.notStarted], value: TemplateStatus.notStarted },
    { key: this.templateStatusLabels[TemplateStatus.workingOnIt], value: TemplateStatus.workingOnIt },
    { key: this.templateStatusLabels[TemplateStatus.review], value: TemplateStatus.review },
    { key: this.templateStatusLabels[TemplateStatus.needsAttention], value: TemplateStatus.needsAttention },
    { key: this.templateStatusLabels[TemplateStatus.complete], value: TemplateStatus.complete },
    { key: 'Starred', value: 'starred' },
  ];

  get statusDropdownOptions() {
    const baseOptions = this.statusList && this.statusList.length ? [...this.statusList] : [...this.defaultStatusList];

    const hasStarredOption = baseOptions.some((option: any) => {
      if (!option) {
        return false;
      }

      if (typeof option === 'string') {
        return option === 'starred';
      }

      return option.value === 'starred';
    });

    if (!hasStarredOption) {
      baseOptions.push({ key: 'Starred', value: 'starred' });
    }

    return baseOptions;
  }

  getStatusButtonClass(status: string | null | undefined): string {
    const key = status ?? TemplateStatus.notStarted;
    return this.templateStatusButtonClassMap[key] ?? '';
  }

  getStatusMenuItemClass(status: string): string {
    return this.templateStatusMenuClassMap[status] ?? '';
  }
  fileListItemToBeUpdated;
  fileListItemsToBeUpdated = [];
  constructor(
    private dialog: MatDialog,
    private toastr: ToastrService,
    private commonService: CommonService,
    private documentService: DocumentService,
    private cd: ChangeDetectorRef,
    private vaultShareService: ShareService,
    private router: Router,
    private notifyEstateActiveTabUpdate: NotifyEstateActiveTabUpdate,
    private notifySummaryUpdateService: NotifySummaryUpdateService,
    private store$: Store<RootStoreState.State>,
    private vaultService: VaultStoreEffects
  ) {
    this.vaultStateObject$ = this.vaultService.vaultObject;

    this.subscription.add(
      this.vaultStateObject$.subscribe((item) => {
        this.stateObject = item;
        this.defaultFolders = item.defaultFolders;

        this.cd.markForCheck();
      })
    );
  }

  resetSelection() {
    this.selectedItemsArray = [];
    this.fileListItems = this.fileListItems.map((item) => ({ ...item, selected: false }));
    this.allChecked = false;
    this.cd.detectChanges();
  }

  getDuplicateCount(): number {
    if (!this.fileListItems || this.fileListItems.length === 0) {
      return 0;
    }

    const formNameCounts = new Map<string, number>();

    this.fileListItems.forEach((item) => {
      // Skip items that are marked as ignore_as_duplicate
      if (item.form_name && !item.ignore_as_duplicate) {
        formNameCounts.set(item.form_name, (formNameCounts.get(item.form_name) || 0) + 1);
      }
    });

    let duplicateCount = 0;
    formNameCounts.forEach((count, formName) => {
      if (count > 1) {
        duplicateCount += count;
      }
    });

    return duplicateCount;
  }

  // Color palette for duplicate groups
  private readonly duplicateColors = ['#D3961A', '#9232B4', '#4599FB', '#FF581B', '#5757DC', '#C8027F'];
  private duplicateColorMap: Map<string, string> = new Map();

  /**
   * Get the color for a duplicate item based on its form_name
   * Groups items with the same form_name together and assigns them the same color
   */
  getDuplicateColor(item: any): string | null {
    if (!item?.form_name || !this.isDuplicateFormName(item.form_name) || item.ignore_as_duplicate) {
      return null;
    }

    // If color already assigned for this form_name, return it
    if (this.duplicateColorMap.has(item.form_name)) {
      return this.duplicateColorMap.get(item.form_name) || null;
    }

    // Get all unique duplicate form names and assign colors
    this.updateDuplicateColorMap();

    return this.duplicateColorMap.get(item.form_name) || null;
  }

  /**
   * Update the color map for all duplicate groups
   */
  private updateDuplicateColorMap(): void {
    this.duplicateColorMap.clear();

    if (!this.fileListItems || this.fileListItems.length === 0) {
      return;
    }

    // Count occurrences of each form name (excluding items marked as ignore_as_duplicate)
    const formNameCounts = new Map<string, number>();
    this.fileListItems.forEach((item) => {
      if (item.form_name && !item.ignore_as_duplicate) {
        formNameCounts.set(item.form_name, (formNameCounts.get(item.form_name) || 0) + 1);
      }
    });

    // Get unique duplicate form names (form names that appear more than once)
    const duplicateFormNames = Array.from(formNameCounts.entries())
      .filter(([_, count]) => count > 1)
      .map(([formName, _]) => formName)
      .sort(); // Sort to ensure consistent ordering

    // Assign colors to each duplicate group
    duplicateFormNames.forEach((formName, index) => {
      const colorIndex = index % this.duplicateColors.length;
      this.duplicateColorMap.set(formName, this.duplicateColors[colorIndex]);
    });
  }

  showOnlyDuplicates = false;
  showLeftScrollBtn = false;
  showRightScrollBtn = false;

  toggleDuplicateFilter() {
    this.showOnlyDuplicates = !this.showOnlyDuplicates;

    // When showing duplicates, automatically sort by name to group them together
    if (this.showOnlyDuplicates) {
      this.sortDuplicatesByName();
      // Update color map when showing duplicates
      this.updateDuplicateColorMap();
    }

    this.toggleDuplicateEvent.emit({});
    this.cd.detectChanges();
  }
  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.screenDataTableHeight = window.innerHeight - 500;
    if (this.screenDataTableHeight < 550) {
      this.screenDataTableHeight = 550;
    }
    if (this.router.url.includes('mydata')) {
      this.is_my_data = true;
    } else {
      this.is_my_data = false;
    }
    if (this.router.url.includes('shared-with-other')) {
      this.is_shared_with_other = true;
    } else {
      this.is_shared_with_other = false;
    }

    // Initialize duplicate color map
    this.updateDuplicateColorMap();

    // Check scroll buttons on initialization
    setTimeout(() => {
      this.checkScrollButtons();
    }, 100);
    setTimeout(() => {}, 5000);
  }

  ngAfterViewInit(): void {
    // Check scroll buttons after view initialization
    setTimeout(() => {
      this.checkScrollButtons();
    }, 200);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.screenDataTableHeight = window.innerHeight - 500;
    if (this.screenDataTableHeight < 550) {
      this.screenDataTableHeight = 550;
    }
    this.checkScrollButtons();
  }

  /**
   * Scroll the filters container left or right
   */
  scrollFilters(direction: 'left' | 'right'): void {
    if (!this.filtersContainer) return;

    const container = this.filtersContainer.nativeElement;
    const scrollAmount = 300; // Pixels to scroll

    if (direction === 'left') {
      container.scrollLeft -= scrollAmount;
    } else {
      container.scrollLeft += scrollAmount;
    }

    // Update button visibility after scrolling
    setTimeout(() => {
      this.checkScrollButtons();
    }, 100);
  }

  /**
   * Handle scroll event on filters container
   */
  onFiltersScroll(): void {
    this.checkScrollButtons();
  }

  /**
   * Get dynamic width for filters container based on button visibility
   */
  getFiltersContainerWidth(): string {
    const filterLabelWidth = 50; // "Filters" label
    const buttonWidth = 40; // Each arrow button
    const gap = 4; // Gap between elements (gap-1 = 0.25rem = 4px)

    let totalOffset = filterLabelWidth;

    // Add gap after filter label
    totalOffset += gap;

    // Add left button width if visible
    if (this.showLeftScrollBtn) {
      totalOffset += buttonWidth + gap;
    }

    // Add right button width if visible
    if (this.showRightScrollBtn) {
      totalOffset += buttonWidth + gap;
    }

    // Add extra padding for safety
    totalOffset += 10;

    return `calc(100% - ${totalOffset}px)`;
  }

  /**
   * Check if scroll buttons should be visible
   * Show buttons based on scroll position and available content
   */
  checkScrollButtons(): void {
    if (!this.filtersContainer) {
      this.showLeftScrollBtn = false;
      this.showRightScrollBtn = false;
      return;
    }

    const container = this.filtersContainer.nativeElement;
    const scrollWidth = container.scrollWidth;
    const clientWidth = container.clientWidth;
    const hasHorizontalScroll = scrollWidth > clientWidth + 2; // 2px tolerance

    // Show buttons whenever there's horizontal overflow, regardless of screen size
    if (!hasHorizontalScroll) {
      // No overflow, hide both buttons
      this.showLeftScrollBtn = false;
      this.showRightScrollBtn = false;
    } else {
      // Has overflow, check scroll position
      const scrollLeft = container.scrollLeft;
      const maxScrollLeft = scrollWidth - clientWidth;

      // Show left button if scrolled away from start
      this.showLeftScrollBtn = scrollLeft > 10;

      // Show right button if not at the end
      this.showRightScrollBtn = scrollLeft < maxScrollLeft - 10;

      // If both would show, only show one based on scroll position
      // Prefer showing the button that indicates more content
      if (this.showLeftScrollBtn && this.showRightScrollBtn) {
        // If scrolled less than halfway, prioritize right button
        if (scrollLeft < maxScrollLeft / 2) {
          this.showLeftScrollBtn = false;
        } else {
          // If scrolled more than halfway, prioritize left button
          this.showRightScrollBtn = false;
        }
      }
    }

    this.cd.detectChanges();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fileListItems']) {
      this.originalFileListItems = undefined;
      this.sortedArrayByStatus = false;

      // Update duplicate color map when fileListItems change
      this.updateDuplicateColorMap();

      if (this.fileListItemToBeUpdated) {
        const findIndexAndRemove = this.fileListItems.findIndex((item_) => item_.id === this.fileListItemToBeUpdated.id);
        this.fileListItems.splice(findIndexAndRemove, 1);
        this.fileListItems.push(this.fileListItemToBeUpdated);
        this.fileListItemToBeUpdated = null;
      }
      if (this.fileListItemsToBeUpdated.length > 0) {
        this.fileListItemsToBeUpdated.forEach((item) => {
          const findIndexAndRemove = this.fileListItems.findIndex((item_) => item_.id === item.id);
          this.fileListItems.splice(findIndexAndRemove, 1);
          this.fileListItems.push(item);
        });
        this.fileListItemsToBeUpdated = [];
        this.cd.detectChanges();
      }
      if (this.initialSort === 'status') {
        // this.sortedArrayByStatus = !this.sortedArrayByStatus;
        // this.sortByStatus();
      }

      if (this.showOnlyDuplicates) {
        this.sortDuplicatesByName();
      }
    }
  }

  templateDocumentGridEvent(event: any) {
    if (event.type === 'viewModal') {
      this.viewModal(event.item, event.event);
    } else if (event.type === 'downloadFile') {
      this.downloadFile(event.item);
    } else if (event.type === 'openShareModal') {
      this.openShareModal(event.item);
    } else if (event.type === 'openCannotShareWarningDilaog') {
      this.openCannotShareWarningDilaog();
    } else if (event.type === 'openCreateShareLinkDialog') {
      this.openCreateShareLinkDialog(event.item);
    } else if (event.type === 'duplicateTemplate') {
      this.duplicateTemplate(event.item);
    } else if (event.type === 'moveAssetSingleItem') {
      this.moveAssetSingleItem(event.item, event.itemId);
    } else if (event.type === 'openActivityLogModel') {
      this.openActivityLogModel(event.item);
    } else if (event.type === 'deleteFileFunction') {
      this.deleteFileFunction(event.item);
    } else if (event.type === 'onValueChange') {
      this.toggleChecklist(event.event, event.file, event.index);
    } else if (event.type === 'toggleChecklistAll') {
      this.toggleChecklistAll(event.event);
    }
  }
  getFormData(id) {
    if (this.stateObject && this.stateObject.forms) {
      return this.stateObject.forms.filter((form) => form.id == id);
    }
  }

  openViewTemplate(titel, name) {
    this.AddTemplateEvent.next({ param1: titel, param2: name, param3: this.id });
  }

  handleSelectChangeEmitter(event, selectedKey) {
    this[selectedKey] = event;
  }

  openShareModal(file) {
    //ensure that id is passed in as vault_user_form_id

    const passingFile = JSON.parse(JSON.stringify(file));
    passingFile.vault_user_form_id = file.id;
    const modalRef2 = this.dialog.open(FileManagerComponent, {
      data: { file: passingFile, isGlobalSearch: this.isGlobalSearch },
      autoFocus: false,
      panelClass: 'full-window-dialog-2',
    });

    this.subscription.add(
      modalRef2.afterClosed().subscribe(() => {
        this.clearSession();
        this.updateUIWIthAPIData();
      })
    );
  }

  duplicateTemplateBulkSelected(event) {
    this.duplicateTemplate(
      this.selectedItemsArray.map((x) => x.id),
      true
    );
  }

  duplicateTemplate(item, isBulk = false) {
    const payload = {
      user_id: this.isGlobalSearch ? item.user_id : this.stateObject.userId,
      vault_user_form_id: isBulk ? item : [item.id],
    };
    this.subscription.add(
      this.documentService.duplicateTemplates(payload).subscribe((res) => {
        this.updateUIWIthAPIData();
        this.clearSession();
        this.toastr.success('File duplicated successfully');
      })
    );
  }

  openActivityLogModel(cardId) {
    const modalRef2 = this.dialog.open(ActivityLogFileComponent, {
      disableClose: true,
      data: {
        isFile: true,
        Id: cardId.id,
        fileFolderName: cardId.form_name,
      },
      panelClass: 'full-window-dialog',
      autoFocus: false,
    });
  }
  toggleChecklistAll(event) {
    this.filteredFileItems.forEach((element, index) => {
      this.someEvent.next({ param1: event, param2: this.filteredFileItems[index] });
      this.filteredFileItems[index]['selected'] = event.source.checked ? true : false;
    });
    this.selectedItemsArray = this.filteredFileItems.filter((item) => item.selected);
  }
  toggleChecklist(event, item, index) {
    if (event.source.checked) {
      this.fileListItems[index]['selected'] = true;
      let filterChecked = this.fileListItems.filter((x) => x.selected);
      if (this.fileListItems.length == filterChecked.length) {
        this.allChecked = true;
      }
    } else if (!event.source.checked) {
      this.allChecked = false;
      this.fileListItems[index]['selected'] = false;
    }
    this.someEvent.next({ param1: event, param2: this.filteredFileItems[index] });
    this.selectedItemsArray = this.filteredFileItems.filter((item) => item.selected);
  }

  moveFormToVault(formId, vault_id, user_id = null, isBulk = false) {
    let data = {
      vault_id: vault_id,
      id: isBulk ? formId : [formId],
      vault_user_id: user_id != null ? user_id : this.stateObject.userId,
    };
    this.subscription.add(
      this.documentService.updateFormGroupId(data).subscribe((res) => {
        this.clearSession();
        this.updateUIWIthAPIData();
        if (isBulk) {
          this.toastr.success(`${formId.length} files moved successfully`);
        } else {
          this.toastr.success('File moved successfully');
        }
      })
    );
  }
  moveFormToGroup(formId, groupId) {
    let data = {
      vault_user_group_id: groupId,
      id: [formId],
    };
    this.subscription.add(
      this.documentService.updateFormGroupId(data).subscribe((res) => {
        this.updateUIWIthAPIData();
        this.toastr.success('File moved successfully');
      })
    );
  }
  downloadFile(item) {
    //if this is a secure form, then promt for security key
    if (item.security_key) {
      const modalRef2 = this.dialog.open(AskSecurityKeyPasswordComponent, {
        data: {
          isRemoveEditSaveSharing: false,
          currentuserId: this.user.id,
          currentValutUserId: this.stateObject.userId,

          data: { security_key: item.security_key },
        },
        disableClose: true,
        panelClass: 'full-window-dialog-2',
        autoFocus: false,
      });
      this.subscription.add(
        modalRef2.afterClosed().subscribe((result) => {
          if (!result.isVerify) {
            return;
          }
          this.sk = result.sk;
          this.security_key = result.security_key;

          this.getFilesToDownload(item);
        })
      );
    } else {
      this.getFilesToDownload(item);
    }
  }
  getFilesToDownload(item) {
    this.subscription.add(
      this.documentService.getUploadedFilesListbyformId(item.vault_user_folder_id, item.id).subscribe(
        (res) => {
          this.files = [];
          res.files.forEach((element) => {
            this.files.push({
              status: 'Done',
              name: element.display_file_name,
              progressbar: 100,
              delete_id: element.id,
              delete_upload_path: res.upload_path,
              created_at: element.created_at,
            });
          });

          //insert a row for the form itself to be downloaded
          this.files.push({
            form_id: item.id,
            name: item.form_name,
          });

          if (this.files.length) {
            this.files.forEach((element, index) => {
              if (element.form_id) {
                this.downloadAttachment(element.form_id, `${element.name}.pdf`, index == this.files.length - 1, true);
              } else {
                if (index == this.files.length - 1) {
                  this.downloadAttachment(element.delete_id, element.name, true);
                } else {
                  this.downloadAttachment(element.delete_id, element.name, false);
                }
              }
            });
          } else {
          }
        },
        (error) => {}
      )
    );
  }

  downloadAttachment(id, name, isStop, is_form_download = false) {
    this.documentService.downloadDocumentOrAttachment(this.stateObject.userId, id, is_form_download ? id : null, this.security_key, this.sk, name);
  }
  viewModal(file, event?: any) {
    let path = event.path || (event.composedPath && event.composedPath());

    if (this.isSharedFiles) {
      file = {
        ...file,
        id: file.vault_user_form_id,
      };
    }

    if (
      path[1].id !== 'toggleMoreWrapper' &&
      path[1].id !== 'checkbox-input-select' &&
      path[1].id !== 'toggleMore' &&
      path[1].classList[0] !== 'see-more__popup' &&
      path[1].classList[0] !== 'popup__wrapper' &&
      path[2].id !== 'kinnect-avatar' &&
      path[1].classList[0] !== 'share-from-stats' &&
      path[0].classList[0] !== 'share-from-stats' &&
      path[0].classList[0] !== 'not-shared-button' &&
      path[0].classList[0] !== 'checkbox-input' &&
      path[1].classList[0] !== 'mat-checkbox-layout' &&
      path[1].classList[1] !== 'Comment-notes-card'
    ) {
      if (this.isSharedFiles && file.share_status === 'future' && !this.isSharedWithOther) {
        const dialogRef = this.dialog.open(InaccessibleWallDialogComponent, {
          data: {
            form_name: file.form_name,
            shareDate: moment(file.sharedDate).format('MMM DD, YYYY'),
            type: file.type,
          },
          height: '520px',
          panelClass: 'full-window-dialog-2',
        });
      } else {
        const dialogOpen = this.dialog.open(AddDocumentComponent, {
          disableClose: true,
          data: { file: file, mode: 'edit', isintelligent: false, isfileListLoad: true },
          panelClass: 'full-window-dialog-add-document',
          autoFocus: false,
        });
        this.subscription.add(
          dialogOpen.afterClosed().subscribe(() => {
            this.updateUiEvent.emit({});
          })
        );
      }
    }
  }
  onDownloadSelectedFiles() {
    for (const item of this.selectedItemsArray) {
      this.downloadFile(item);
    }
    this.clearSession();
  }
  updateUIWIthAPIData() {
    if (this.globalSearch || this.isGlobalSearch) {
      this.updateUiEvent.emit({});
    } else {
      this.subscription.add(this.notifyEstateActiveTabUpdate.sendMessage('true'));
    }
    if (this.templateIdsToBeUpdated.length > 0) {
      this.templateIdsToBeUpdated = [];
      this.cd.detectChanges();
    }
  }
  UnShareFileFunction() {
    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Unshare file',
        materialIcon: 'delete',
        imageSrc: 'assets/images/unshare-white.svg',
        text: `Are you sure you want to unshare the selected templates?`,
        proceedTitle: 'Unshare',
      },
    });
    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          let completedFilescount = 0;
          let totalFilesCount = this.selectedItemsArray.length;
          this.selectedItemsArray.forEach((file) => {
            this.subscription.add(
              this.vaultShareService
                .deleteFormShare({
                  user_id: this.stateObject.userId,
                  id: file.share_id,
                })
                .subscribe((results) => {
                  completedFilescount++;
                  if (completedFilescount == totalFilesCount) {
                    this.toastr.success(`${totalFilesCount} files unshared successfully`);
                    this.clearSession();
                    this.updateUIWIthAPIData();
                  }
                  if (this.is_shared_with_other) {
                    this.store$.dispatch(new vaultStoreActions.SharedDataByMeRequest({}));
                  }
                })
            );
          });
        }
      })
    );
  }

  UnShareSingeFileFunction(file) {
    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Unshare file?',
        imageSrc: 'assets/images/unshare-white.svg',
        materialIcon: 'delete',
        text: `Are you sure you want to unshare the template?`,
        proceedTitle: 'Unshare',
      },
    });
    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          this.subscription.add(
            this.vaultShareService
              .deleteFormShare({
                user_id: this.stateObject.userId,
                id: file.share_id,
              })
              .subscribe((results) => {
                this.toastr.success(`${file.form_name} File unshared successfully`);

                this.clearSession();
                this.updateUIWIthAPIData();
                this.cd.markForCheck();
                if (this.is_shared_with_other) {
                  this.store$.dispatch(new vaultStoreActions.SharedDataByMeRequest({}));
                }
              })
          );
        }
      })
    );
  }

  deleteFileFunction(file) {
    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Move to trash?',
        materialIcon: 'delete',
        text: `This file will be deleted forever from your trash after ${foreverDeletedRemainingDays} days.`,
        proceedTitle: 'Move to Trash',
        // ...(file.organization_section.toL === 'Entities' && { checkBoxTitle: `Also delete the vault ${file?.vault_name}` }),
        entityFiles: file.organization_section?.toLocaleLowerCase() === 'entities' ? [file] : [],
      },
    });
    this.subscription.add(
      sharedDialogRef
        .afterClosed()
        .pipe(takeWhile(() => this.componentActive))
        .subscribe((data) => {
          const { confirmation, deleteAllChecked, entityIds } = data;
          if (confirmation) {
            const modelRequest = {
              type: 'form',
              ids: [file.id],
            };

            this.subscription.add(
              this.commonService
                .moveToTrashForm(modelRequest)
                .pipe(takeWhile(() => this.componentActive))
                .subscribe((data) => {
                  if (data) {
                    this.toastr.success(`${file.form_name} file moved to trash`);
                    this.updateUIWIthAPIData();
                  }
                })
            );

            if (deleteAllChecked || entityIds) {
              this.subscription.add(
                this.commonService
                  .moveToTrashForm({
                    type: 'vault',
                    ids: entityIds ? entityIds : [file.v_id],
                  })
                  .pipe(takeWhile(() => this.componentActive))
                  .subscribe((data) => {
                    if (data) {
                      this.store$.dispatch(new vaultStoreActions.GetVaultRequestAction(this.stateObject?.userId, false));
                      // if stateObject.vaultId is === file.v_id, then redirect to the vault page
                      if (this.stateObject?.vaultId === file.v_id) {
                        this.router.navigate(['/vault']);
                      }
                    }
                  })
              );
            }
          }
        })
    );
  }

  getConnectedList(): any[] {
    return this.group.map((x) => `${x.id}`);
  }
  clearSession() {
    try {
      this.handleClearSelection();
    } catch (error) {}
  }
  moveAssetItem() {
    let title = this.selectedItemsArray.length > 1 ? `Move ${this.selectedItemsArray.length} files to` : `Move file to`;
    const dialogRef = this.dialog.open(AddFolderDialogWithVaultComponent, {
      // width: '300px',
      panelClass: 'attachment-move',
      data: { vaultObject: null, defaultFolders: this.defaultFolders, title: title, includeSubfolders: true, hideGroup: false },
    });

    this.subscription.add(
      dialogRef.afterClosed().subscribe((data) => {
        if (data.confirmation && data.vault_id) {
          this.moveFormToVault(
            this.selectedItemsArray.map(({ id }) => id),
            data.vault_id,
            data.user_id,
            true
          );
        }
      })
    );
  }
  deleteFileFunctionAllSelectedFiles() {
    const entityFiles = this.selectedItemsArray.filter((file) => file.organization_section?.toLocaleLowerCase() === 'entities');
    const removeDuplicateEntityFiles = entityFiles.filter((file, index, self) => index === self.findIndex((t) => t.vault_id === file.vault_id));
    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Move to trash?',
        materialIcon: 'delete',
        text: `This file will be deleted forever from your trash after ${foreverDeletedRemainingDays} days.`,
        proceedTitle: 'Move to Trash',
        entityFiles: removeDuplicateEntityFiles,
      },
    });
    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((data) => {
        const { confirmation, entityIds } = data;
        if (confirmation) {
          // this.store$.dispatch(new vaultStoreActions.DeleteFileRequest(model));
          const modelRequest = {
            type: 'form',
            ids: this.selectedItemsArray.map(({ id }) => id),
          };

          this.subscription.add(
            this.commonService.moveToTrashForm(modelRequest).subscribe((data) => {
              if (data) {
                this.toastr.success(`${this.selectedItemsArray.map(({ id }) => id).length > 1 ? 'files' : 'file'}  moved to trash`);
                this.clearSession();
                this.updateUIWIthAPIData();
              }
            })
          );
          if (entityIds) {
            this.subscription.add(
              this.commonService
                .moveToTrashForm({
                  type: 'vault',
                  ids: !Array.isArray(entityIds) ? [entityIds] : entityIds,
                })
                .pipe(takeWhile(() => this.componentActive))
                .subscribe((data) => {
                  if (data) {
                    this.store$.dispatch(new vaultStoreActions.GetVaultRequestAction(this.stateObject?.userId, false));
                    // if stateObject.vaultId is included in entityIds, then redirect to the vault page
                    if (entityIds.includes(this.stateObject?.vaultId)) {
                      this.router.navigate(['/vault']);
                    }
                  }
                })
            );
          }
        }
      })
    );
  }
  moveChecklists(event) {
    if (event === 'clearSelection') {
      this.clearSession();
    } else if (event === 'move') {
      this.moveAssetItem();
    } else if (event === 'share') {
      this.shareChecklist();
    } else if (event === 'deleteChecklist') {
      this.deleteFileFunctionAllSelectedFiles();
    } else if (event === 'download') {
      this.onDownloadSelectedFiles();
    } else if (event === 'unShareFile') {
      this.UnShareFileFunction();
    } else if (event?.type === 'templateStatus') {
      this.handleTemplatesStatusChange(event?.value);
    }
  }
  shareChecklist() {
    let passingFile = JSON.parse(JSON.stringify(this.selectedItemsArray[0]));
    passingFile = {
      ...passingFile,
      vault_user_form_id: passingFile.vufid,
      currentFormId: passingFile.vufid,
    };

    const modalRef2 = this.dialog.open(FileManagerComponent, {
      data: {
        file: passingFile,
        selectedItemsArray: this.selectedItemsArray.map((x) => ({
          ...x,
          vault_user_form_id: x.id,
        })),
        showMarkAsComplete: false,
        markAsCompleteStatus: 'created',
        ask_mark_complete: false,
      },
      panelClass: 'full-window-dialog-2',
      autoFocus: false,
    });
    this.subscription.add(
      modalRef2.afterClosed().subscribe((data) => {
        this.clearSession();
        this.updateUIWIthAPIData();
      })
    );
  }
  moveAssetSingleItem(item, itemId) {
    const dialogRef = this.dialog.open(AddFolderDialogWithVaultComponent, {
      // width: '300px',
      panelClass: 'attachment-move',
      data: { vaultObject: null, defaultFolders: this.defaultFolders, title: 'Move File To', includeSubfolders: true, hideGroup: false },
    });

    this.subscription.add(
      dialogRef.afterClosed().subscribe((data) => {
        if (data.confirmation && data.vault_id) {
          this.moveFormToVault(item.id, data.vault_id);
        } else if (data.confirmation && data.subfolderSelected) {
          this.moveFormToGroup(item.id, data.subfolderSelected.vaultFolderId);
        }
      })
    );
  }

  openTemplateRegister(event) {
    this.openTemplateRegisterEvent.emit(event);
  }

  openCreateShareLinkDialog(item) {
    const dialogRef = this.dialog.open(CreateShareLinkComponent, {
      panelClass: 'create-share-link-dialog',
      data: { vaultFormId: item.id, formName: item.form_name },
    });

    this.subscription.add(dialogRef.afterClosed().subscribe((data) => {}));
  }

  openCannotShareWarningDilaog() {
    this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      height: '194px',
      data: {
        title: 'Cannot share link',
        materialIcon: 'warning',
        text: 'You cannot share link’s from a protected file',
        proceedTitle: 'Ok',
      },
    });
  }

  sortByAccessible() {
    this.sortedArrayByAccessible = !this.sortedArrayByAccessible;
    this.initialSort = 'accessible';
    if (this.sortedArrayByAccessible) {
      const sortedByStatus = this.fileListItems.slice().sort((a, b) => a.share_status.localeCompare(b.share_status));
      this.fileListItems = [...sortedByStatus];
    } else {
      const nextSortedByStatus = this.fileListItems.slice().sort((a, b) => b.share_status.localeCompare(a.share_status));
      this.fileListItems = [...nextSortedByStatus];
    }
  }

  sortByName() {
    this.initialSort = 'name';
    this.sortedArrayByStatus = false;
    if (this.sortedArrayByName == false) {
      const sortedByName = this.fileListItems.sort((a, b) =>
        a.form_name.trim().toLowerCase() > b.form_name.trim().toLowerCase()
          ? 1
          : b.form_name.trim().toLowerCase() > a.form_name.trim().toLowerCase()
          ? -1
          : 0
      );
      this.fileListItems = [...sortedByName];
      this.sortedArrayByName = !this.sortedArrayByName;
    } else {
      const nextSortedByName = this.fileListItems.sort((a, b) =>
        b.form_name.trim().toLowerCase() > a.form_name.trim().toLowerCase()
          ? 1
          : a.form_name.trim().toLowerCase() > b.form_name.trim().toLowerCase()
          ? -1
          : 0
      );
      this.fileListItems = [...nextSortedByName];
      this.sortedArrayByName = !this.sortedArrayByName;
    }
    this.cd.detectChanges();
  }
  originalFileListItems;
  sortByStatus() {
    this.sortedArrayByStatus = !this.sortedArrayByStatus;
    this.initialSort = 'status';

    // If turning the sort ON
    if (this.sortedArrayByStatus) {
      // Save original order if not already saved
      if (!this.originalFileListItems) {
        this.originalFileListItems = [...this.fileListItems];
      }
      // Sort by 'complete' status at the top
      const sortedByStatus = this.fileListItems.slice().sort((a, b) => {
        const aComplete = a?.template_status === 'complete' ? 0 : 1;
        const bComplete = b?.template_status === 'complete' ? 0 : 1;
        return aComplete - bComplete;
      });

      this.fileListItems = [...sortedByStatus];
      // log the first 10 items
    } else {
      // Restore original order
      if (this.originalFileListItems) {
        this.fileListItems = [...this.originalFileListItems];
      }

      if (!this.originalFileListItems) {
        this.originalFileListItems = [...this.fileListItems];
      }
      // Sort by 'complete' status at the top
      const sortedByStatus = this.fileListItems.slice().sort((a, b) => {
        const aComplete = a?.template_status === 'workingOnIt' ? 0 : 1;
        const bComplete = b?.template_status === 'workingOnIt' ? 0 : 1;
        return aComplete - bComplete;
      });

      this.fileListItems = [...sortedByStatus];
    }
  }
  sortByCreatedDate() {
    this.sortedArrayByName = false;
    this.sortedArrayBySize = false;
    this.sortedArrayByStatus = false;
    this.initialSort = 'type';

    if (this.sortedArrayByType == false) {
      const sortedByType = this.fileListItems.slice().sort((a, b) => new Date(a.updated_at).getTime() - new Date(b.updated_at).getTime());
      this.fileListItems = [...sortedByType];
      this.sortedArrayByType = !this.sortedArrayByType;
    } else {
      const nextSortedByType = this.fileListItems.slice().sort((a, b) => new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime());
      this.fileListItems = [...nextSortedByType];
      this.sortedArrayByType = !this.sortedArrayByType;
    }
    this.cd.detectChanges();
  }

  sortByTags() {
    this.sortedArrayByTags = !this.sortedArrayByTags;
    this.initialSort = 'tags';
    this.sortedArrayByName = false;
    this.sortedArrayByStatus = false;
    this.sortedArrayByType = false;
    this.sortedArrayBySize = false;

    if (this.sortedArrayByTags) {
      const sortedByTags = this.fileListItems.slice().sort((a, b) => {
        const aTags = this.getTagList(a);
        const bTags = this.getTagList(b);
        return bTags - aTags; // Sort by number of tags (descending)
      });
      this.fileListItems = [...sortedByTags];
    } else {
      const nextSortedByTags = this.fileListItems.slice().sort((a, b) => {
        const aTags = this.getTagList(a);
        const bTags = this.getTagList(b);
        return aTags - bTags; // Sort by number of tags (ascending)
      });
      this.fileListItems = [...nextSortedByTags];
    }
    this.cd.detectChanges();
  }

  sortByLinks() {
    this.sortedArrayByLinks = !this.sortedArrayByLinks;
    this.initialSort = 'links';
    this.sortedArrayByName = false;
    this.sortedArrayByStatus = false;
    this.sortedArrayByType = false;
    this.sortedArrayBySize = false;
    this.sortedArrayByTags = false;

    if (this.sortedArrayByLinks) {
      const sortedByLinks = this.fileListItems.slice().sort((a, b) => {
        const aLinks = a.count_linking;
        const bLinks = b.count_linking;
        return bLinks - aLinks; // Sort by number of links (descending)
      });
      this.fileListItems = [...sortedByLinks];
    } else {
      const nextSortedByLinks = this.fileListItems.slice().sort((a, b) => {
        const aLinks = a.count_linking;
        const bLinks = b.count_linking;
        return aLinks - bLinks; // Sort by number of links (ascending)
      });
      this.fileListItems = [...nextSortedByLinks];
    }
    this.cd.detectChanges();
  }

  get filteredItems() {
    let filteredItems = [...this.fileListItems];

    // Filter by search text
    if (this.searchText && this.searchText.trim().length > 0) {
      const searchLower = this.searchText.trim().toLowerCase();
      filteredItems = filteredItems.filter((item) => {
        return (
          item.form_name?.toLowerCase().includes(searchLower) ||
          item.file_name?.toLowerCase().includes(searchLower) ||
          item.type?.toLowerCase().includes(searchLower)
        );
      });
    }

    // Filter by duplicates if showOnlyDuplicates is true
    if (this.showOnlyDuplicates) {
      // First, identify which form_names are duplicates (excluding items marked as ignore_as_duplicate)
      const formNameCounts = new Map<string, number>();
      filteredItems.forEach((item) => {
        if (item.form_name && !item.ignore_as_duplicate) {
          formNameCounts.set(item.form_name, (formNameCounts.get(item.form_name) || 0) + 1);
        }
      });

      // Filter to only items with duplicate form_names (excluding items marked as ignore_as_duplicate)
      filteredItems = filteredItems.filter((item) => {
        return item.form_name && !item.ignore_as_duplicate && formNameCounts.get(item.form_name) > 1;
      });
    }

    if (this.filterValue && this.filterValue.length > 0) {
      filteredItems = filteredItems.filter((item) => this.filterValue.includes(item.template_type));
    }

    if (this.selectedDocumentTypeFilter && this.selectedDocumentTypeFilter.length > 0) {
      filteredItems = filteredItems.filter((item) => {
        const fileType = item.attachment_type || getFileExtension(item.file_name);
        return this.selectedDocumentTypeFilter.includes(fileType);
      });
    }

    if (this.selectedSenderFilter && this.selectedSenderFilter.length > 0) {
      filteredItems = filteredItems.filter((item) => {
        const sender = item.from_name || 'Unknown Sender';
        return this.selectedSenderFilter.includes(sender);
      });
    }

    if (this.selectedSourceFilter && this.selectedSourceFilter.length > 0) {
      filteredItems = filteredItems.filter((item) => {
        const source = item.vault_user_form_uploads_origin || 'Unknown Source';
        return this.selectedSourceFilter.includes(source);
      });
    }

    if (this.selectedLastUpdatedList && this.selectedLastUpdatedList.length > 0) {
      filteredItems = filteredItems.filter((item) => {
        const dateAdded = item.formatted_updated_at;
        return this.selectedLastUpdatedList.includes(dateAdded);
      });
    }
    if (this.document_type) {
      if (this.selectedTypeList && this.selectedTypeList.length > 0) {
        filteredItems = filteredItems.filter((item) => {
          const type = item.document_type;
          return this.selectedTypeList.includes(type);
        });
      }
    } else {
      if (this.selectedTypeList && this.selectedTypeList.length > 0) {
        filteredItems = filteredItems.filter((item) => {
          const type = item.type;
          return this.selectedTypeList.includes(type);
        });
      }
    }

    if (this.selectedVaultList && this.selectedVaultList.length > 0) {
      filteredItems = filteredItems.filter((item) => {
        const vault = item.vault_id;
        return this.selectedVaultList.includes(vault);
      });
    }
    if (this.selectedStatusList && this.selectedStatusList.length > 0) {
      const includesStarred = this.selectedStatusList.includes('starred');
      const statusFilters = this.selectedStatusList.filter((status) => status !== 'starred');

      filteredItems = filteredItems.filter((item) => {
        const status = item.template_status;
        const isStarred = item?.is_starred === true || item?.is_starred === 1;
        const matchesStarFilter = !includesStarred || isStarred;
        const matchesStatusFilter = statusFilters.length === 0 || statusFilters.includes(status);
        return matchesStarFilter && matchesStatusFilter;
      });
    }

    if (this.selectedDateAddedList && this.selectedDateAddedList.length > 0 && this.selectedDateAddedList !== 'All Time') {
      const accepted = [];

      if (this.selectedDateAddedList === 'Today') {
        accepted.push('Today');
      } else if (this.selectedDateAddedList === 'Past 7 Days') {
        accepted.push('Today', 'Past 7 Days');
      } else if (this.selectedDateAddedList === 'Past 30 Days') {
        accepted.push('Today', 'Past 7 Days', 'Past 30 Days');
      } else if (this.selectedDateAddedList === 'This Year') {
        accepted.push('Today', 'Past 7 Days', 'Past 30 Days', 'This Year');
      }
      filteredItems = filteredItems.filter((item) => {
        const dateAdded = item.updated_at_last_updated;
        return accepted.includes(dateAdded);
      });
    }
    this.filteredFileItems = filteredItems;
    return filteredItems;
  }

  toggleItemStar(event: MouseEvent, item: any): void {
    event.stopPropagation();
    event.preventDefault();

    const itemId = this.getItemStarId(item);
    if (!itemId) {
      return;
    }

    const key = this.getStarMapKey(itemId);

    if (!key || this.starUpdatingMap[key]) {
      return;
    }

    const nextValue = !item?.is_starred;

    this.starUpdatingMap = { ...this.starUpdatingMap, [key]: true };
    item.is_starred = nextValue;
    this.cd.markForCheck();

    this.subscription.add(
      this.documentService
        .updateFormIsStarred(
          {
            id: itemId,
            is_starred: nextValue,
          },
          false
        )
        .subscribe({
          next: () => {
            this.starUpdatingMap = { ...this.starUpdatingMap, [key]: false };
            this.cd.markForCheck();
          },
          error: () => {
            item.is_starred = !nextValue;
            this.starUpdatingMap = { ...this.starUpdatingMap, [key]: false };
            this.toastr.error('Failed to update starred status');
            this.cd.markForCheck();
          },
        })
    );
  }

  isStarUpdating(itemId: string | undefined | null): boolean {
    const key = this.getStarMapKey(itemId);
    return key ? this.starUpdatingMap[key] === true : false;
  }

  private getStarMapKey(itemId: string | undefined | null): string {
    if (!itemId) {
      return '';
    }

    return itemId;
  }

  getItemStarId(item: any): string | null {
    if (!item) {
      return null;
    }

    const id = item.id ?? item.vault_user_form_id;
    if (id === undefined || id === null) {
      return null;
    }

    return String(id);
  }

  ngOnDestroy(): void {
    this.componentActive = false;
    this.subscription?.unsubscribe();
  }
  getTagList(item) {
    if (!item.tag) return false;

    try {
      const tagData = JSON.parse(item.tag);
      if (tagData.document_type) {
        // Split by comma and trim whitespace
        const documentTypes = tagData.document_type.split(',').map((type: string) => type.trim());
        // Check if any of the selected tags match any of the document types
        return documentTypes.length;
      }
    } catch (error) {
      console.error('Error parsing tag data:', error);
    }
  }

  getTagSuggestions(item) {
    if (!item.tag_suggestion) return 0;
    try {
      // Handle comma-separated string format like "Real Estate, Asset, Ownership, Legal Entity"
      if (typeof item.tag_suggestion === 'string') {
        // Check if it's a comma-separated string
        if (item.tag_suggestion.includes(',')) {
          const tagSuggestions = item.tag_suggestion
            .split(',')
            .map((tag) => tag.trim())
            .filter((tag) => tag.length > 0);

          // Get document types to filter out from tag suggestions
          let documentTypes = [];
          if (item.tag) {
            try {
              const tagData = JSON.parse(item.tag);
              if (tagData.document_type) {
                documentTypes = tagData.document_type.split(',').map((type: string) => type.trim());
              }
            } catch (error) {
              console.error('Error parsing tag data for filtering:', error);
            }
          }

          // Filter out tag suggestions that are already present in document types
          const filteredTagSuggestions = tagSuggestions.filter(
            (suggestion) => !documentTypes.some((docType) => docType.toLowerCase() === suggestion.toLowerCase())
          );

          return filteredTagSuggestions.length;
        }
      }
      return 0;
    } catch (error) {
      console.error('Error parsing tag suggestions:', error);
      return 0;
    }
  }

  handleStatusMenu(event) {
    event.stopPropagation();
    event.preventDefault();
    const target = event.target as HTMLElement;
    const classEl = document.querySelectorAll('.statusMenu');
    if (target) {
      const computedStyle = window.getComputedStyle(target);
      const { width } = computedStyle;
      classEl.forEach((element: HTMLElement) => {
        element.style.minWidth = width;
        element.style.width = width;
        this.cd.detectChanges();
      });

      const statusWrapper = document.querySelector('.mat-mdc-menu-content');
      if (statusWrapper) {
        (statusWrapper as any).style.padding = '0';
      }
      const statusItem = document.querySelectorAll('.mat-mdc-menu-item-text');
      statusItem.forEach((element: HTMLElement) => {
        element.style.fontSize = '12px';
        element.style.fontWeight = '600';
      });
      this.cd.detectChanges();
    }
  }
  templateIdsToBeUpdated = [];
  handleTemplateStatusChange(status: TemplateStatus | string, item) {
    const currentStatus = (item?.template_status as string) || TemplateStatus.notStarted;
    if (status === currentStatus) {
      return;
    }
    if (status === TemplateStatus.complete) {
      this.templateIdsToBeUpdated.push(item.id);
    }
    this.fileListItemToBeUpdated = { ...item, template_status: status };
    this.cd.detectChanges();
    this.subscription.add(
      this.documentService
        .updateVaultFormTemplateStatus({
          templateIds: [item.id],
          templateStatus: status,
        })
        .subscribe((res) => {
          this.updateUIWIthAPIData();
        })
    );
  }
  handleTemplatesStatusChange(value: TemplateStatus | string) {
    const resolvedValue = (value as TemplateStatus) || TemplateStatus.notStarted;
    const templateIds = this.selectedItemsArray
      .filter((item) => (item.template_status || TemplateStatus.notStarted) !== resolvedValue)
      .map((item) => item.id);
    if (resolvedValue === TemplateStatus.complete) {
      this.templateIdsToBeUpdated = [...templateIds];
    }
    if (templateIds.length === 0) {
      this.selectedItemsArray = [];
      this.filteredItems.forEach((item) => {
        item.selected = false;
      });
      this.cd.detectChanges();
      return;
    }
    this.fileListItemsToBeUpdated = this.fileListItems.filter((item) => templateIds.includes(item.id));
    this.subscription.add(
      this.documentService
        .updateVaultFormTemplateStatus({
          templateIds,
          templateStatus: resolvedValue,
        })
        .subscribe((res) => {
          this.selectedItemsArray = [];
          this.fileListItems.forEach((item) => {
            if (templateIds.includes(item.id)) {
              item.template_status = resolvedValue;
            }
          });
          this.allChecked = false;
          this.cd.detectChanges();
          this.updateUIWIthAPIData();
        })
    );
  }

  handleClearSelection() {
    this.selectedItemsArray = [];
    this.fileListItems.forEach((item) => {
      item.selected = false;
    });
    this.allChecked = false;
  }

  ignoreAsDuplicate(event: Event, item: any) {
    event.stopPropagation();

    const sharedDialogRef = this.dialog.open(SharedConfirmationDialogComponent, {
      width: '400px',
      data: {
        title: 'Mark as Not a Duplicate?',
        materialIcon: 'info',
        blueBg: true,
        text: `Do you want to mark ${item?.form_name || 'this document'} as Not a Duplicate?`,
        proceedTitle: 'Yes',
        showCancelBtn: true,
      },
    });

    this.subscription.add(
      sharedDialogRef.afterClosed().subscribe((confirmation) => {
        if (confirmation) {
          const payload = {
            id: item.id,
            ignore_as_duplicate: true,
          };

          this.subscription.add(
            this.documentService.ignoreAsDuplicate(payload).subscribe(
              (res) => {
                // Update the item locally immediately
                item.ignore_as_duplicate = true;

                // Update the duplicate color map to reflect the change
                this.updateDuplicateColorMap();

                // Check if there are any duplicates left after ignoring this one
                const remainingDuplicates = this.getDuplicateCount();

                // If no duplicates remain and duplicate filter is active, turn it off
                if (remainingDuplicates === 0 && this.showOnlyDuplicates) {
                  this.showOnlyDuplicates = false;
                }

                this.toastr.success('Duplicate ignored successfully');
                if (this.showOnlyDuplicates) {
                  this.sortDuplicatesByName();
                }
                this.updateUIWIthAPIData();
                this.cd.detectChanges();
              },
              (error) => {
                this.toastr.error(error?.error?.message || 'Failed to ignore duplicate');
              }
            )
          );
        }
      })
    );
  }

  getFileExtensionOnly(fileName: string): string {
    if (!fileName) {
      return 'doc';
    }
    const lastDotIndex = fileName.lastIndexOf('.');
    if (lastDotIndex === -1) {
      return 'doc';
    }
    return fileName.substring(lastDotIndex + 1).toLowerCase();
  }

  private sortDuplicatesByName(): void {
    if (!this.fileListItems?.length) {
      return;
    }

    const sortedByNameAsc = [...this.fileListItems].sort((a, b) => {
      const nameA = (a.form_name || '').trim().toLowerCase();
      const nameB = (b.form_name || '').trim().toLowerCase();
      if (nameA > nameB) return 1;
      if (nameA < nameB) return -1;
      return 0;
    });

    this.fileListItems = sortedByNameAsc;
    this.sortedArrayByName = true;
    this.initialSort = 'name';
    this.cd.markForCheck();
  }
}
